export default "__VITE_ASSET__CZhkqjJ8__"